import React from 'react';
import {BenchmarkLegend as SharedBenchmarkLegend, NoteBanner as SharedNoteBanner} from '../../DashboardCommon/widgets.comp';

/* The School dashboard's widgets live in `pages/DashboardCommon/widgets.comp.jsx`
   (one copy for School, Network and Partner). This file keeps the School
   defaults so its importers do not change. */
export * from '../../DashboardCommon/widgets.comp';

export const BenchmarkLegend = (props) => <SharedBenchmarkLegend seriesLabel="School score" {...props}/>;
export const NoteBanner = (props) => <SharedNoteBanner mt={3} {...props}/>;
